/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderMale = createReactComponent("outline", "gender-male", "IconGenderMale", [["path", { "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M19 5l-5.4 5.4", "key": "svg-1" }], ["path", { "d": "M19 5h-5", "key": "svg-2" }], ["path", { "d": "M19 5v5", "key": "svg-3" }]]);

export { IconGenderMale as default };
//# sourceMappingURL=IconGenderMale.mjs.map
